import { render, staticRenderFns } from "./AddOwnersForm.vue?vue&type=template&id=aaba609a&scoped=true"
import script from "./AddOwnersForm.vue?vue&type=script&lang=js"
export * from "./AddOwnersForm.vue?vue&type=script&lang=js"
import style0 from "./AddOwnersForm.vue?vue&type=style&index=0&id=aaba609a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaba609a",
  null
  
)

export default component.exports